import countryIsdCode from '@/countryIsd'
import { getAddressDataFromLatLong } from '../services/address'
import { Success } from '@/statusCodes.js'

export function askToUserPermissionForLocation() {
	return new Promise((resolve, reject) => {
		if (!('geolocation' in navigator)) reject('gelocation not supported')

		navigator.geolocation.getCurrentPosition(
			(position) => resolve(position), // on success
			(error) => reject(error), // on error
			{
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0
			} // options
		)
	})
}

async function getAddressesFromUserLatLong(position) {
	if (!position) return { data: undefined, error: 'Position is required' }

	try {
		const { data, error } = await getAddressDataFromLatLong(position.latitude, position.longitude)

		if (error || data.StatusCode !== Success) throw new Error('Cant find location at the moment')

		const { results } = data.Data

		// if "GEOMETRIC_CENTER" not found fallback to "ROOFTOP" location
		const userLocation =
			results.find((result) => result?.geometry.location_type === 'GEOMETRIC_CENTER') ??
			results.find((result) => result?.geometry.location_type === 'ROOFTOP')

		if (!userLocation) throw new Error('Cant find user location')

		const locationData = { city: null, state: null, country: null, isdCode: null }

		for (let address of userLocation.address_components) {
			// state
			if (address?.types?.includes('administrative_area_level_1')) {
				locationData.state = address.long_name
			}
			// city
			if (address?.types?.includes('locality') || address?.types?.includes('postal_town')) {
				locationData.city = address.long_name
			}

			// country
			if (address?.types?.includes('country')) {
				locationData.country = address.long_name
			}
		}

		const myCountry = countryIsdCode.find(
			(c) => c.name.toLowerCase() === locationData.country.toLowerCase()
		)

		// isdCode
		if (myCountry) locationData.isdCode = myCountry.code.replace('+', '')

		return { data: locationData, error: undefined }
	} catch (e) {
		return { data: undefined, error: e }
	}
}

export async function getUserAddressLocationData() {
	try {
		const position = await askToUserPermissionForLocation()
		if (!position) throw new Error('No position')
		const { data, error } = await getAddressesFromUserLatLong(position.coords)

		if (error) throw new Error(error)

		return { data: { ...data, position }, error: undefined }
	} catch (e) {
		return { data: undefined, error: e }
	}
}
